// eslint-disable-next-line @typescript-eslint/no-unused-vars
const scrollBehavior = async (to, from, savedPosition) => {
  const DEFAULT_Y_OFFSET = 54;
  const nuxt = window.$nuxt;
  const isRouteChanged = to !== from;
  let position = false;
  const yOffset = DEFAULT_Y_OFFSET;

  if (savedPosition && to.name === 'index') {
    position = savedPosition;
  } else {
    position = { x: 0, y: 0 };
    if (yOffset) {
      position.offset = { y: yOffset };
    }
  }

  if (!isRouteChanged || (to.path === from.path && to.hash)) {
    nuxt.$nextTick(() => nuxt.$emit('triggerScroll'));
  }

  return new Promise((resolve) => {
    nuxt.$once('triggerScroll', async () => {
      if (to.hash) {
        let { hash } = to;

        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = `#${window.CSS.escape(hash.substr(1))}`;
        }

        try {
          const el = document.querySelector(hash);

          if (el) {
            // scroll to anchor by returning the selector
            position.selector = hash;
            if (!navigator.userAgent.includes('Firefox')) {
              position.behavior = 'smooth';
            }
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      }

      resolve({ ...position });
    });
  });
};

export default scrollBehavior;
